import { Fragment } from 'react';
import { Table, TabPane  } from 'reactstrap';
import { Code, CountUnit, DateCreated, DateModified, Description, InventoryClass, InventoryGroup, MinOrderQuantity, Name, OrderingTime, ReorderLevel, Status, StorageMode } from '../../../../../../Constant';
import DataTableComponent from "../../../../../Common/Component/DataTableComponent";
import useInventoryType from "./controller";
import ViewModal from '../../../../../Common/Component/ViewModal';
import { formatDateWithTimeZone } from '../../../../../../_helper/dateHelper';

const InventoryTypeList = (name: any) => {
    const {
        data,
        tableColumns,
        handleView,
        handleEdit,
        viewModalOpen,
        selectedRowData,
        setViewModalOpen,
        formFields,
        memoizedHandleEdit,
        editMode,
        title,
        loading,
    } = useInventoryType();

    return (
        <Fragment>
            <TabPane className='fade show' tabId={name.name}>
                <DataTableComponent
                    tabledata={data}
                    tableColumns={tableColumns}
                    isLoading={loading}
                    onView={handleView}
                    // onDelete={handleDelete}
                    onEdit={handleEdit}
                    useTableAction={undefined}
                    addToDefaultAction={undefined}
                    onDelete={undefined}
                />

                <ViewModal
                    isOpen={viewModalOpen}
                    toggle={() => setViewModalOpen(!viewModalOpen)}
                    rowData={selectedRowData}
                    formFields={formFields}
                    editMode={editMode}
                    onEdit={memoizedHandleEdit}
                    onSubmit={undefined}
                    modalTitle={undefined}
                >
                    {selectedRowData && (
                    <>
                        <Table>
                        <tbody>
                            <tr className="border-bottom-primary">
                                <th scope="row">{Name}</th>
                                <td>{selectedRowData.name}</td>
                            </tr>

                            <tr className="border-bottom-primary">
                                <th scope="row">{Code}</th>
                                <td>{selectedRowData.code}</td>
                            </tr>

                            <tr className="border-bottom-primary">
                                <th scope="row">{CountUnit}</th>
                                <td>{selectedRowData.count_unit}</td>
                            </tr>

                            <tr className="border-bottom-primary">
                                <th scope="row">{ReorderLevel}</th>
                                <td>{selectedRowData.reorder_level}</td>
                            </tr>

                            <tr className="border-bottom-primary">
                                <th scope="row">{MinOrderQuantity}</th>
                                <td>{selectedRowData.min_order_quantity}</td>
                            </tr>

                            <tr className="border-bottom-primary">
                                <th scope="row">{OrderingTime}</th>
                                <td>{selectedRowData.ordering_time}</td>
                            </tr>

                            <tr className="border-bottom-primary">
                                <th scope="row">{StorageMode}</th>
                                <td>{selectedRowData.administration_storage_mode.name}</td>
                            </tr>

                            <tr className="border-bottom-primary">
                                <th scope="row">{InventoryClass}</th>
                                <td>{selectedRowData.administration_inventory_class.name}</td>
                            </tr>

                            <tr className="border-bottom-primary">
                                <th scope="row">{InventoryGroup}</th>
                                <td>{selectedRowData.administration_inventory_class.administration_inventory_group.name}</td>
                            </tr>

                            <tr className="border-bottom-primary">
                            <th scope="row">{Description}</th>
                            <td>{selectedRowData.description}</td>
                            </tr>

                            <tr className="border-bottom-primary">
                            <th scope="row">{Status}</th>
                            <td>
                                {selectedRowData.is_active ? (
                                <span className="badge badge-light-success">
                                    Active
                                </span>
                                ) : (
                                <span className="badge badge-light-danger">
                                    Inactive
                                </span>
                                )}
                            </td>
                            </tr>
                            <tr className="border-bottom-primary">
                            <th scope="row">{DateCreated}</th>
                            <td>
                                {formatDateWithTimeZone(selectedRowData.created_at)}
                            </td>
                            </tr>

                            <tr className="border-bottom-primary">
                            <th scope="row">{DateModified}</th>
                            <td>
                                {formatDateWithTimeZone(selectedRowData.updated_at)}
                            </td>
                            </tr>
                        </tbody>
                        </Table>
                    </>
                    )}
                </ViewModal>
            </TabPane>
        </Fragment>
    );
}

export default  InventoryTypeList